const aaa = [
  {
    path: "aaa",
    component: () => import("@/views/mendian/aaa.vue"),
    meta: { title: "收银" },
  },
  {
    path: "shouyin",
    component: () => import("@/views/mendian/shouyin/shouyin1.vue"),
    meta: { title: "收银" },
  },
  {
    path: "xizao",
    component: () => import("@/views/mendian/shouyin/shouyin.vue"),
    meta: { title: "洗澡" },
  },
  {
    path: "meirong",
    component: () => import("@/views/mendian/shouyin/shouyin.vue"),
    meta: { title: "美容" },
  },
  {
    path: "jiyang",
    component: () => import("@/views/mendian/shouyin/shouyin.vue"),
    meta: { title: "寄养" },
  },
  {
    path: "huangou",
    component: () => import("@/views/mendian/shouyin/shouyin.vue"),
    meta: { title: "换购" },
  },
  {
    path: "dingdan",
    component: () => import("@/views/dingdan/order/order.vue"),
    meta: { title: "订单", keepAlive: true },
  },
  {
    path: "addUser",
    component: () => import("@/views/mendian/addUser/addUser.vue"),
    meta: { title: "新增顾客" },
  },
  // 门店预约 预约排班  预约配置
 
 
  {
    path: "yuyue",
    component: () => import("@/views/mendian/yuyue/list.vue"),
    meta: { title: "预约", keepAlive: true },
  },
  {
    path: "tixing",
    component: () => import("@/views/mendian/shouyin/shouyin.vue"),
    meta: { title: "提醒" },
  },
  {
    path: "chongzhi",
    component: () => import("@/views/mendian/chongzhi/chongzhi.vue"),
    meta: { title: "充值" },
  }
];
export default aaa;
